<template>
  <body class="main-body">
    <div class="flex-container">
      <div class="company-header">
        <div class="left-box">
          <p class="-company">{{widgetData.companyName}}</p>
          <!-- todo:ミニロボ周りが表示できるように改修を行う -->
          <!-- <p class="-name">{{target}}</p> -->
        </div>
      </div>
      <div style="position: fixed; z-index: 1000; width: 100vw; height: 100vh; border-bottom-right-radius: 10px; border-bottom-left-radius: 10px; background: white; top: 0; left: 0;" v-if="!isMessage">
        <Loading/>
      </div>
      <!-- ロボリスト -->
      <template v-if="formData">
        <div class="robo-list" v-if="formData.robo_list.length > 0">
          <template v-for="(robo, idx) in formData.robo_list">
            <div class="workday-tooltip" v-if="isOffDuty(robo, widgetData.todayIsHoliday)">
              <div class="tooltip-workday-message">{{getWorkDayMessage(robo)}}<br>{{getWorkTimeMessage(robo)}}</div>
              <div class="robo-form" v-if="getRoboName(robo) != ''">
                  <img class="robo-icon" :class="{'selected-icon': robo === botid}" :src="getRoboIcon(robo)"/>
                  <p :class="{'selected-name': robo === botid}">
                    {{getRoboName(robo)}}
                  </p>
              </div>
            </div>
            <div v-else>
              <Tooltip
                :key="idx"
                :message="robo === botid ? '現在このロボが対応中です。' : (getRoboName(robo) + 'に切り替えます。')">
                <div class="robo-form" @click="changeRobo(robo)" v-if="getRoboName(robo) != ''">
                    <img class="robo-icon" :class="{'selected-icon': robo === botid}" :src="getRoboIcon(robo)"/>
                    <p :class="{'selected-name': robo === botid}">
                      {{getRoboName(robo)}}
                    </p>
                </div>
              </Tooltip>
            </div>
          </template>
        </div>
      </template>
      <!-- チャット画面 -->
      <div class="main-container" :class="{'-main-exist-robo': isExistRoboList(formData)}">
        <div style="width: 100%; height: 100%; padding: 16px; position: absolute; background: #f8f8f8ee; z-index: 999;" v-if="!isOnLine || ws==null">
          現在接続がされておりません。<br>
          すぐに再接続しますか？<br>
          （自動でも再接続されます）<br><br>
          <a class="button is-primary" @click="reconnect()">再接続する</a>
        </div>
        <div style="width: 100%; height: 100%; padding: 16px; position: absolute; background: #f8f8f8ee; z-index: 999;" v-else-if="!chatbot.is_confirm">
          現在メンテナンス中です。
        </div>
        <div style="width: 100%; height: 100%; padding: 16px; position: absolute; background: #f8f8f8ee; z-index: 999;" v-else-if="isOffDutyFlag">
          ただいま稼働時間外です。<br>
          稼働時間については下記をご参照ください。<br><br>
          {{getWorkDayMessage(chatbot.pk)}}<br>
          {{getWorkTimeMessage(chatbot.pk)}}
        </div>
        <div style="width: 100%; height: 100%; padding: 16px; position: absolute; background: #f8f8f8ee; z-index: 999;" v-else-if="this.lastView">
          以前にこのロボとやりとりしたことがあります。<br>
          続きから再開しますか？<br><br>
          <a class="button is-primary" @click="scenarioStart('top')">最初から始める</a>
          <a class="button is-primary" @click="scenarioStart('continue')">続きから始める</a>
        </div>
        <div class="chat-dialog" v-if="chatLogs" @click="nextScenario()">
          <Balloon
            v-for="(chat,index) in chatLogs" :key="index"
            :speaker="chat.speaker"
            :name="chat.name"
            :icon="chat.icon"
            :message="chat.message"
            :time="displayDate(chat)"
            :readTime="new Date(widgetData.readTime)"
            :isBot="chat.isBot"
            :email="chat.email"
            :isManager="chat.isManager"
            :logIndex="index"
            :lastIndex="chatLogs.length - 1"
            :files="chat.files"
            :filename="chat.filename"
            :status="chat.status"
            :parameter="chat.parameter"
            :companyData="widgetData"
            :roboPartsSetOutsideScenario="roboPartsSetOutsideScenario"
            :roboPartsSetNextNode="roboPartsSetNextNode"
            @setLocalStorage="setLocalStorage">
          </Balloon>
          <MogoMogo v-if="isTyping||isSCNLoading||isRecommendScheduleLoading||messageLoading"/>
          <div style="height: 42px; width: 200px;" v-else></div>
          <div style="height: 176px;"></div>
          <template v-if="chatLogs.length > 0">
            <div class="tap-box" v-if="(chatLogs[chatLogs.length-1].status == 2||chatLogs[chatLogs.length-1].status == 5||chatLogs[chatLogs.length-1].status == 14||chatLogs[chatLogs.length-1].status == 19)">
              <div v-if="!talkEnd">
                <div class="huyuu">
                  <span class="mdi mdi-gesture-double-tap mdi-36px"></span>
                </div>
                <div>タップ/クリックをすることで<br>次へ進みます。</div>
              </div>
              <div v-else>
                <div v-if="isQuestionnaire">
                  <ModalChatBotQuestionnaire
                    :isShowModal = "isShowModal"
                    :bot_id = "q_botid"
                    :seeker_id = "seeker.id"
                    :company_id = "companyid"
                    @cancel="cancelModal"/>
                </div>
              </div>
            </div>
            <div class="tap-box" v-else-if="talkEnd && isQuestionnaire">
              <ModalChatBotQuestionnaire
                :isShowModal = "isShowModal"
                :bot_id = "q_botid"
                :seeker_id = "seeker.id"
                :company_id = "companyid"
                @cancel="cancelModal"/>
            </div> 
          </template>
        </div>
        <div class="auto-button-wrapper">
          <button class="button is-small is-primary auto-button" @click="$clickAutoBtn(false)" v-if="isAutomatic">
            <span class="mdi mdi-spin mdi-autorenew" style="margin-right: 8px;"></span>自動
          </button>
          <button class="button is-small auto-button" @click="$clickAutoBtn(true)" v-if="!isAutomatic">
            <span class="mdi mdi-autorenew" style="margin-right: 8px;"></span>自動
          </button>
        </div>
      </div>
    </div>
  </body>
</template>

<script>
import moment                  from 'moment'
import Balloon                 from '@/components/ui/Balloon'
import MogoMogo                from '@/components/ui/MogoMogo'
import Loading                 from '@/components/animations/Loading'
import watchScenarioMixin      from '@/mixins/watchScenarioMixin'
import chatbotSingleMixin      from '@/mixins/chatbotSingleMixin'
import connectCheckMixin      from '@/mixins/connectCheckMixin'
import Tooltip                 from '@/components/atoms/tooltips/Tooltip'
import ModalChatBotQuestionnaire from '@/components/ChatBot/organisms/ModalChatBotQuestionnaire'
import {
  isOffDuty,
  getWorkDayMessage,
  getWorkTimeMessage,
} from '@/functions/robo/roboOffDuty'
export default {
  components: {
    Loading,
    Balloon,
    MogoMogo,
    Tooltip,
    ModalChatBotQuestionnaire
  },
  mixins: [
    watchScenarioMixin,
    chatbotSingleMixin,
    connectCheckMixin,
  ],
  data () {
    return {
      formData: null,
      isOffDutyFlag: false,
      isQuestionnaire: false,
      isShowModal: false,
      q_botid: '',
      form_bots: []
    }
  },
  mounted () {
    // 最初にロボと会社が存在するかチェック後初期処理を行う
    if (this.$route.params.companyid && this.$route.params.contentsid) {
      this.$store.dispatch('chatbot/getFromContentsChatBot', {
        cid: this.$route.params.companyid,
        ctsid: this.$route.params.contentsid
      }).then((d) => {
        if (d) {
          this.init(d)
          this.formData = d
          this.form_bots = []
          for (let robo_id of this.formData.robo_list) {
            this.$store.dispatch('directtalk/getRoboInfo', {'robo_id/mini_pk': robo_id})
            .then((bot_info) => {
              if (bot_info) this.form_bots.push(bot_info)
            })
          }
        } else {
          alert('ロボを取得できませんでした。URLをもう一度ご確認の上アクセスをお願いいたします。')
          location.href = '/404' + '?cid=' + this.$route.params.companyid
        }
      })
    } else if (this.$route.params.companyid) {
      alert('ロボを取得できませんでした。URLをもう一度ご確認の上アクセスをお願いいたします。')
      location.href = '/404' + '?cid=' + this.$route.params.companyid
    } else {
      alert('ロボを取得できませんでした。URLをもう一度ご確認の上アクセスをお願いいたします。')
      location.href = '/404'
    }
  },
  watch: {
    async 'widgetData.name' () {
      this.isMessage = true
      let bot_info = undefined
      if (this.minipk) {
        bot_info = await this.$store.dispatch('directtalk/getRoboInfo', {'mini_robo_pk': this.minipk})
      } else {
        bot_info = await this.$store.dispatch('directtalk/getRoboInfo', {'robo_id': this.botid})
      }
      if (bot_info) {
        this.$store.dispatch('auth/slackPost', {companyID: this.data.ckey, seekerID: this.seeker.id, msg: ''})
        this.$store.dispatch('auth/CWPost', {companyID: this.data.ckey, seekerID: this.seeker.id, msg: ''})
        this.chatbot = bot_info
      }
    },
    chatbot () {
      // 過去の会話ログは表示しない
      this.$store.dispatch('directtalk/initializeChatLogs')
      // ロボの稼働時間チェック
      this.isOffDutyFlag = isOffDuty(this.chatbot, this.widgetData.todayIsHoliday)
      //アンケート表示の設定取得
      this.isQuestionnaire = this.chatbot.is_questionnaire
      this.q_botid = this.chatbot.bot_id
    },
    talkEnd () {
      if (this.talkEnd) {
        this.isShowModal = true
      }
    }
  },
  methods: {
    // 初期処理
    async init (res) {
      // 訪問者情報の割当
      this.userData.url = location.href
      this.userData.appname = window.navigator.appName
      this.userData.platform = window.navigator.platform
      this.userData.width = window.screen.width
      this.userData.height = window.screen.height
      this.userData.color = window.screen.colorDepth
      this.userData.referrer = document.referrer
      this.userData.useragent = window.navigator.userAgent
      this.userData.ckey = this.$route.params.companyid
      this.userData.cookies = document.cookie
      this.userData.sessionid = localStorage.getItem('SID_' + this.$route.params.companyid)
      this.userData.count = localStorage.getItem('CNT_' + this.$route.params.contentsid)
      this.companyid = this.$route.params.companyid
      this.botid = this.getBotID(res)
      this.$store.dispatch('chatbot/setMiniPK', this.getMiniPK(res))
      let bot_info = undefined
      if (this.minipk) {
        bot_info = await this.$store.dispatch('directtalk/getRoboInfo', {'mini_robo_pk': this.minipk})
      } else {
        bot_info = await this.$store.dispatch('directtalk/getRoboInfo', {'robo_id': this.botid})
      }
      if (bot_info) {
        this.$store.dispatch('auth/slackPost', {companyID: this.data.ckey, seekerID: this.seeker.id, msg: ''})
        this.$store.dispatch('auth/CWPost', {companyID: this.data.ckey, seekerID: this.seeker.id, msg: ''})
        this.chatbot = bot_info
      }
      this.$store.dispatch('directtalk/setJson', this.userData)
      document.addEventListener('DOMFocusIn', ((event) => {
        // キーボードが出現した時
        this.$store.dispatch('directtalk/mobileType')
      }), false)
      document.addEventListener('DOMFocusOut', ((event) => {
        // キーボードが引っ込んだ時
        this.$store.dispatch('directtalk/mobileType')
      }), false)
      document.addEventListener('visibilitychange', this.handleVisibilityChange, false)
      window.addEventListener('resize', () => {
        let vh = window.innerHeight * 0.01
        document.documentElement.style.setProperty('--vh', `${vh}px`)
      })
    },
    getBotID (res) {
      if (res.start_robo) {
        return res.start_robo
      } else if (res.oubonavi) {
        return res.oubonavi
      } else {
        return res.robo_list[0]
      }
    },
    getMiniPK (res) {
      if (res.minipk) {
        return res.minipk
      } else {
        return null
      }
    },
    async changeRobo (robo) {
      this.$store.dispatch('chatbot/mountChatPage')

      let bot_info = await this.$store.dispatch('directtalk/getRoboInfo', {'robo_id/mini_pk': robo})
      if (bot_info) {
        this.chatbot = bot_info
        this.botid = robo
        // ミニロボのばあい
        if (bot_info.pk) {
          this.$store.dispatch('chatbot/setMiniPK', bot_info.pk)
        } else {
          this.$store.dispatch('chatbot/setMiniPK', null)
        }
      }
    },
    isOffDuty (robo, todayIsHoliday) {
      // ロボ非番判定
      for (const info of this.form_bots) {
        if (info.bot_id === robo || info.pk === robo) {
          return isOffDuty(info, todayIsHoliday)
        }
      }
    },
    getWorkDayMessage (robo) {
      // 稼働日メッセージ取得
      for (const info of this.form_bots) {
        if (info.bot_id === robo || info.pk === robo) {
          return getWorkDayMessage(info)
        }
      }
    },
    getWorkTimeMessage (robo) {
      // 稼働時間メッセージ取得
      for (const info of this.form_bots) {
        if (info.bot_id === robo || info.pk === robo) {
          return getWorkTimeMessage(info)
        }
      }
    },
    getRoboIcon (robo) {
      for (const info of this.form_bots) {
        if (info.bot_id === robo) {
          if (info.icon_data) return info.icon_data
          break
        }
      }
      return require('@/assets/template/robot.png')
    },
    getRoboName (robo) {
      for (const info of this.form_bots) {
        if (info.bot_id === robo || info.pk === robo) {
          if (info.display_name) return info.display_name
          break
        }
      }
      return ''
    },
    isExistRoboList (formData) {
      if (formData) {
        if (formData.robo_list.length > 0) return true
      }
      return false
    },
    displayDate(chat) {
      if (!isNaN(chat.createdAt)) {
        return new Date(chat.createdAt)
      } else {
        return new Date(chat.createdAtOther)
      }
    },
    cancelModal () {
      this.isShowModal = false
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
html, body, .main-body {
  width: 100vw;
  height: 100vh !important;
  overflow: hidden !important;
  margin: 0 auto;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
}
.flex-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.main-container {
  display: flex;
  flex-direction: column;
  height: calc(100% - 72px);
  position: relative;
  box-shadow: 0 2px 4px 2px rgba(0,0,0,0.1);
}
.loading-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #fff;
  box-shadow: 0 2px 4px 2px rgba(0,0,0,0.1);
}
.entry {
  font-weight: bold;
}
.button-wrapper {
  .button {
    margin-top: 24px;
    width: 160px;
  }
}
.company-header{
  background: #f8f8f8;
  height: 72px;
  padding: 4px 24px;
  display: flex;
  justify-content: center;
  flex-direction: column-reverse;
  box-shadow: 0 2px 4px 2px rgba(0,0,0,0.1);
  .-name {
    text-align: left;
    font-size: 16px;
    font-weight: 600;
  }
  .-company {
    text-align: left;
    font-size: 13px;
  }
}
.chat-dialog {
  height: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  scroll-behavior: smooth;
  background-color: #fff;
}
.chat-dialog::-webkit-scrollbar {
  width: 10px;
  height: 10px;
  visibility: hidden;
}
.input-button {
  background: transparent;
  border: none;
  resize: none;
  outline:none;
}

.parent-form {
  width: 100%;
  background: #F8F8F8;
  border-top: solid thin #CCC;
}
.child-form {
  text-align: center;
  padding-bottom: 0px !important;
  min-height: 45px;
  background: #F8F8F8;
}
textarea {
  min-width: calc(100% - 40px);
  max-width: calc(100% - 40px);
  font-size: 18px;
  border: none;
  resize: none;
  outline:none;
  line-height: 25px;
  padding-top: 10px;
  padding-left: 8px;
}
.loading-form {
  height: 20px;
  background-color: transparent;
  font-size: 16px;
}
.loading span {
  display: inline-block;
  margin: 0 -.05em;
  margin-left: 10px;
  animation: loading .7s infinite;
}
.loading span:nth-child(2) {
  animation-delay: .1s;
}
.loading span:nth-child(3) {
  animation-delay: .2s;
}
.loading span:nth-child(4) {
  animation-delay: .3s;
}
.loading span:nth-child(5) {
  animation-delay: .4s;
}
.loading span:nth-child(6) {
  animation-delay: .5s;
}
.loading span:nth-child(7) {
  animation-delay: .6s;
}
@keyframes loading {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-15px);
  }
}
.list {
  height: 80vh;
}
.chat-list-enter-active, .chat-list-leave-active {
  transition: all 1s;
}
.chat-list-enter, .chat-list-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.mogomogo-enter-active, .mogomogo-leave-active {
  transition: all 1s;
}
.mogomogo-enter, .mogomogo-leave-to {
  position: absolute;
  transform: scale(0);
}
.huyuu {
  animation: huwahuwa 2s ease-out;
  animation-iteration-count: infinite;
}
@keyframes huwahuwa {
  0% {
    transform: translateY(0px) scale(0.8);
  }
  50% {
    transform: translateY(-7.5px) scale(0.8);
  }
  100% {
    transform: translateY(0px) scale(0.8);
  }
}
.footer-area {
  display: flex;
  justify-content: space-between;
}
.left-block, .right-block {
  width: 96px;
}
.center-block {
  display: flex;
  justify-content: center;
  align-items: center;
}
.auto-button {
  border-radius: 16px;
}
.tap-box {
  position: absolute;
  bottom: 16px;
  left: 0;
  right: 0;
  margin: auto;
  height: 160px;
}
.auto-button-wrapper {
  position: absolute;
  bottom: 16px;
  right: 16px;
}
.-main-exist-robo {
  height: calc(100% - 160px);
}
.robo-list {
  height: 88px;
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  overflow-x: scroll;
  .robo-form {
    width: 80px;
    margin: 0 16px;
    text-align: center;
    cursor: pointer;
    /deep/.tooltip {
      display: block;
      width: 80px;
    }
    p {
      font-size: 13px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      margin-top: -4px;
    }
    .robo-icon {
      height: 48px;
      width: 48px;
      object-fit: cover;
      border-radius: 50%;
      border: solid thin #ccc;
      margin-top: 4px;
      transition: 0.5s;
    }
    .robo-icon:hover {
      transform: scale(1.05);
    }
    .selected-icon {
      border: solid 3px #b22;
    }
    .selected-name {
      font-weight: 600;
      color: #b22;
      text-decoration: underline;
    }
  }
}
.workday-tooltip{
  position : relative;
  cursor   : pointer;
  display  : inline-block;
}
.tooltip-workday-message {
  display       : none;
  position      : absolute;
  color         : #fff;
  background    : #363636;
  padding       : 8px;
  font-size     : 12px;
  border-radius : 5px;
  width         : 200px;
  z-index       : 10;
  text-align: center;
}
.tooltip-workday-message:before {
  content    : "";
  position   : absolute;
  top        : -20px;
  left       : 10px;
  border     : 15px solid transparent;
  border-top : 15px solid #363636;
  transform  : rotateZ(180deg);
}
.workday-tooltip:hover .tooltip-workday-message{
  display : inline-block;
  top     : 34px;
  left    : -15px;
}
</style>



// WEBPACK FOOTER //
// src/views/RecruitLP/ChatBotForm.vue